import { render } from "./TheProfessionalInterConsultation.vue?vue&type=template&id=7a68792e&scoped=true&ts=true"
import script from "./TheProfessionalInterConsultation.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalInterConsultation.vue?vue&type=script&lang=ts"

import "./TheProfessionalInterConsultation.vue?vue&type=style&index=0&id=7a68792e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a68792e"]])

export default __exports__